import React from "react";

interface Props {
  platform: "android" | "ios" | "web";
}

export default function PlatformBadge({ platform }: Props) {
  const icon = platform === "web" ? "🌐" : "📱";
  const colors: Record<string, string> = {
    web: "var(--color-info)",
    android: "var(--color-success)",
    ios: "var(--color-text-secondary)",
  };
  return (
    <span
      title={`Platform: ${platform}`}
      data-platform={platform}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "0.25em",
        padding: "2px 8px",
        borderRadius: "var(--radius-sm)",
        fontSize: "var(--font-size-sm)",
        fontWeight: 500,
        background: "var(--color-foreground)",
        color: colors[platform] ?? "var(--color-text-primary)",
        whiteSpace: "nowrap",
      }}
    >
      {icon} {platform}
    </span>
  );
}
